<template>
  <svg
    :class="direction && `rotate-icon--${direction}`"
    width="15"
    height="12"
    viewBox="0 0 15 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.5303 5.46967C14.8232 5.76256 14.8232 6.23744 14.5303 6.53033L9.75736 11.3033C9.46447 11.5962 8.98959 11.5962 8.6967 11.3033C8.40381 11.0104 8.40381 10.5355 8.6967 10.2426L12.9393 6L8.6967 1.75736C8.40381 1.46447 8.40381 0.989593 8.6967 0.696699C8.98959 0.403806 9.46447 0.403806 9.75736 0.696699L14.5303 5.46967ZM0 5.25L14 5.25V6.75L0 6.75L0 5.25Z"
      fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'ArrowLine',
  props: {
    direction: {
      type: String,
      default: '',
    },
  },
};
</script>
